<div
  *ngIf="model"
  class="result-title-container"
  #resultTitle
  [escape]="false"
  [pTooltip]="tooltipText"
  [tooltipPosition]="tooltipPosition"
  tooltipStyleClass="u-tooltip"
>
  <u-icon class="icon" *ngIf="model.icon" [model]="iconModel"></u-icon>
  <span
    id="text"
    data-cy="result-title-text"
    [dragAndDrop]="dragData"
    class="text"
    [innerHTML]="text | highlight : highlights : highlightStyle"
  ></span>
  <ng-content></ng-content>
</div>
